import React from 'react';
import { motion } from 'framer-motion';
import { Heart, CheckCircle2 } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function PromiseSection() {
  const {
    t
  } = useTranslation();
  return <section id="promise" className="py-24 bg-lavender-50 relative overflow-hidden" data-id="element-464">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-465">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-10 md:p-16 shadow-xl border border-lavender-100 relative text-center" data-id="element-466">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-blush-100 rounded-full flex items-center justify-center shadow-sm border-4 border-white" data-id="element-467">
            <Heart className="w-5 h-5 text-blush-500 fill-blush-500" data-id="element-468" />
          </div>

          <h2 className="font-serif text-4xl text-gray-900 mb-8 mt-4" data-id="element-469">
            {t.promise.heading}
          </h2>

          <div className="space-y-6 text-lg text-gray-600 leading-relaxed mb-10" data-id="element-470">
            <p data-id="element-471">{t.promise.body1}</p>
            <p data-id="element-472">{t.promise.body2}</p>
          </div>

          <div className="bg-cream-50 p-6 rounded-xl border border-lavender-100 flex items-start gap-4 text-left mb-8" data-id="element-473">
            <CheckCircle2 className="w-6 h-6 text-lavender-600 flex-shrink-0 mt-1" data-id="element-474" />
            <p className="font-medium text-gray-800" data-id="element-475">{t.promise.guarantee}</p>
          </div>

          <p className="font-script text-3xl text-lavender-600" data-id="element-476">
            {t.promise.signature}
          </p>
        </motion.div>
      </div>
    </section>;
}